import { Breadcrumbs } from "@sembark-travel/ui-router"
import { Helmet } from "react-helmet-async"
import { AutoDistribution } from "../../Leads"
import { ForbidUnlessAuthorized, PERMISSIONS } from "../../Auth"
import { generatePath } from "../../router-utils"

export default function AutoDistributionPreferences() {
	return (
		<>
			<Helmet>
				<title>Auto Distribution Preferences</title>
			</Helmet>
			<Breadcrumbs
				title="Auto Distribution Preferences"
				items={[
					[generatePath("/trip-plan-requests"), "Leads"],
					["", "Auto Distribution"],
				]}
			/>
			<ForbidUnlessAuthorized
				permission={PERMISSIONS.MANAGE_TRIP_PLAN_REQUESTS}
			>
				<AutoDistribution />
			</ForbidUnlessAuthorized>
		</>
	)
}
